import React, { useState } from "react";
import HTMLReactParser from "html-react-parser";
import { useParams } from "react-router-dom";
import millify from "millify";
import { Col, Row, Typography, Select } from "antd";
import {
  MoneyCollectOutlined,
  DollarCircleOutlined,
  FundOutlined,
  ExclamationCircleOutlined,
  StopOutlined,
  TrophyOutlined,
  CheckOutlined,
  NumberOutlined,
} from "@ant-design/icons";

import {
  useGetCryptoDetailsQuery,
  useGetCryptoHistoryQuery,
} from "../services/cryptoApi";
import Loader from "./Loader";
import LineChart from "./LineChart";

const { Title, Text } = Typography;
const { Option } = Select;

const CryptoDetails = () => {
  const { coinId } = useParams();
  const [timePeriod, setTimePeriod] = useState("7d");
  const { data, isFetching } = useGetCryptoDetailsQuery(coinId);
  console.log(data);
  const { data: coinHistory } = useGetCryptoHistoryQuery({
    coinId,
    timePeriod,
  });
  console.log(data);
  const cryptoDetails = data?.data?.coin;

  if (isFetching) return <Loader />;

  const time = ["3h", "24h", "7d", "30d", "3m", "1y", "3y", "5y"];

  const stats = [
    {
      id: "1",
      title: "Price to USD",
      value: `$ ${cryptoDetails.price && millify(cryptoDetails.price)}`,
      icon: <DollarCircleOutlined />,
    },
    {
      id: "2",
      title: "Rank",
      value: cryptoDetails.rank ? cryptoDetails.rank : "N/A",
      icon: <NumberOutlined />,
    },
    // {
    //   id: "3",
    //   title: "24h Volume",
    //   value: `${
    //     cryptoDetails["24hVolume"] && millify(cryptoDetails["24hVolume"])
    //   }`
    //     ? cryptoDetails["24hVolume"] && millify(cryptoDetails["24hVolume"])
    //     : "N/A",
    //   icon: <ThunderboltOutlined />,
    // },
    {
      id: "4",
      title: "Market Cap",
      value: `$ ${cryptoDetails.marketCap && millify(cryptoDetails.marketCap)}`
        ? cryptoDetails.marketCap && millify(cryptoDetails.marketCap)
        : "N/A",
      icon: <DollarCircleOutlined />,
    },
    {
      id: "5",
      title: "All-time-high(daily avg.)",
      value: `$ ${millify(cryptoDetails.allTimeHigh.price)}`
        ? millify(cryptoDetails.allTimeHigh.price)
        : "N/A",
      icon: <TrophyOutlined />,
    },
  ];

  const genericStats = [
    {
      id: "1",
      title: "Number Of Markets",
      value: cryptoDetails.numberOfMarkets
        ? cryptoDetails.numberOfMarkets
        : "N/A",
      icon: <FundOutlined />,
    },
    {
      id: "2",
      title: "Number Of Exchanges",
      value: cryptoDetails.numberOfExchanges
        ? cryptoDetails.numberOfExchanges
        : "N/A",
      icon: <MoneyCollectOutlined />,
    },
    {
      id: "3",
      title: "Aprroved Supply",
      value: cryptoDetails.supply.confirmed ? (
        <CheckOutlined />
      ) : (
        <StopOutlined />
      ),
      icon: <ExclamationCircleOutlined />,
    },
    {
      id: "4",
      title: "Total Supply",
      value: cryptoDetails.supply.total
        ? `$ ${millify(cryptoDetails.supply.total)}`
        : "N/A",
      icon: <ExclamationCircleOutlined />,
    },
    {
      id: "5",
      title: "Circulating Supply",
      value: cryptoDetails.supply.circulating
        ? `$ ${millify(cryptoDetails.supply.circulating)}`
        : "N/A",
      icon: <ExclamationCircleOutlined />,
    },
  ];

  return (
    <Col className="coin-detail-container">
      <Col className="coin-heading-container">
        <Title level={2} className="coin-name">
          {cryptoDetails.name} ({cryptoDetails.symbol}) Price
        </Title>
        <p>
          {cryptoDetails.name} live price in US Dollar (USD). View value
          statistics, market cap and supply.
        </p>
      </Col>
      <Select
        defaultValue="7d"
        className="select-timeperiod"
        placeholder="Select Time Period"
        onChange={(value) => setTimePeriod(value)}
      >
        {time.map((date) => (
          <Option key={date}>{date}</Option>
        ))}
      </Select>

      <LineChart
        coinHistory={coinHistory}
        currentPrice={millify(cryptoDetails.price)}
        coinName={cryptoDetails.name}
      />

      <Col className="stats-container">
        <Col className="coin-value-statistics">
          <Col className="coin-value-statistics-headaing">
            <Title level={3} className="coin-detailes-heading">
              {cryptoDetails.name} Value Statistics
            </Title>
            <p>An overview showing the stats of {cryptoDetails.name}</p>
          </Col>
          {stats.map(({ icon, title, value, index }) => (
            <Col className="coin-stats" key={index}>
              <Col className="coin-stats-name">
                <Text>{icon}</Text>
                <Text>{title}</Text>
              </Col>
              <Text className="stats">{value}</Text>
            </Col>
          ))}
        </Col>
        <Col className="other-stats-info">
          <Col className="coin-value-statistics-headaing">
            <Title level={3} className="coin-detailes-heading">
              Other Statistics
            </Title>
            <p>An overview showing the stats of all cryptocurrencies</p>
          </Col>
          {genericStats.map(({ icon, title, value, id }) => (
            <Col className="coin-stats" key={id}>
              <Col className="coin-stats-name">
                <Text>{icon}</Text>
                <Text>{title}</Text>
              </Col>
              <Text className="stats">{value}</Text>
            </Col>
          ))}
        </Col>
      </Col>
      <Col className="coin-desc-link">
        <Row className="coin-desc">
          <Title level={3} className="coin-details-heading">
            What is {cryptoDetails.name}
          </Title>
          {HTMLReactParser(cryptoDetails.description)}
        </Row>
        <Col className="coin-links">
          <Title level={3} className="coin-details-heading">
            {cryptoDetails.name} Links
          </Title>
          {cryptoDetails.links.map((link) => (
            <Row className="coin-link" key={link.name}>
              <Title level={5} className="link-name">
                {link.type}
              </Title>
              <a href={link.url} target="_blank" rel="noreferrer">
                {link.name}
              </a>
            </Row>
          ))}
        </Col>
      </Col>
    </Col>
  );
};

export default CryptoDetails;
